import React from "react"

import SelectButton from '../../form_sections/SelectButton'
import StandardModal from '../../app_components/StandardModal'

class GenderFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      needGenderModal: false,
    }

    this.userGenderText = this.userGenderText.bind(this)
    this.selectGender = this.selectGender.bind(this)
  }

  userGenderText() {
    switch (this.props.userGender) {
      case 2:
        return 'Women'
      case 3:
        return 'Men'
      default:
        return 'Not set'
    }
  }

  selectGender(userGender) {
    if (this.props.userGender !== 2 && this.props.userGender !== 3) {
      this.setState({ needGenderModal: true })
    } else if (!this.props.premiumUser) {
      this.props.toggleProModal('filter')
    } else {
      this.props.updateGender(userGender)
    }
  }

  render() {
    return (
      <section className="matchFiltersModal__card">
        {this.state.needGenderModal && (
          <StandardModal onClose={() => this.setState({ needGenderModal: false })}>
            <h3 className="matchFiltersModal__alertTitle">Add your gender first</h3>
            <p className="matchFiltersModal__alertText">
              Save your gender in settings to use this filter.
            </p>
            <button
              type="button"
              className="button_primary"
              onClick={() => window.location.assign('/edit')}
            >
              Go to settings
            </button>
          </StandardModal>
        )}

        <div className="matchFiltersModal__sectionHeader">
          <h3 className="matchFiltersModal__sectionTitle">Gender</h3>
          <span className="matchFiltersModal__proBadge">Pro</span>
        </div>
        <p className="matchFiltersModal__sectionHint">
          Match with your gender or everyone.
        </p>
        <div className="matchFiltersModal__chipGroup matchFiltersModal__chipGroup--grid">
          <SelectButton
            morphism
            selected={this.props.selectedGender > 1}
            onClick={() => this.selectGender(this.props.userGender)}
            buttonText={`My gender (${this.userGenderText()})`}
          />
          <SelectButton
            morphism
            selected={this.props.selectedGender < 2}
            onClick={() => this.selectGender(1)}
            buttonText="Everyone"
          />
        </div>
      </section>
    )
  }
}

export default GenderFilter
